module.exports = __webpack_public_path__ + "img/layouts.4aeb9e51.png";